/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 7/19/2023
 */
import React, { useEffect, useState } from "react"
import "../../../../styleSheets/base/styles.scss"
import "../styles/terminals.styles.scss"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Chip,
} from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import api from "../../../../base/services/ResApi"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"
import OrgsDropdown from "../../../components/orgsDropdown/OrgsDropdown"
import GroupsDropdown from "../../../components/groupsDropdown/GroupsDropdown"
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling"
import Alerts from "../../../../base/errorHandeling/Alerts"
import TerminalModelsDropdown from "../../../components/terminalModels/TerminalModelsDropdown"

const CreateTerminalsModal = ({
  open,
  onClose,
  setUpdateData,
  orgCode,
  grpId,
}) => {
  const [data, setData] = useState([])
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])
  const [isBtnLoading, setIsBtnLoading] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)

  const [iserror, setIserror] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  const [organiCode, setOrganiCode] = useState()
  const [groupId, setGroupId] = useState()
  const [model, setModel] = useState()

  const [newTerminals, setNewTerminals] = useState([])
  const [isadded, setIsAdded] = useState(false)

  useEffect(() => {
    setOrganiCode(orgCode)
  }, [orgCode])

  useEffect(() => {
    setGroupId(grpId)
  }, [grpId])

  const handleClearData = () => {
    setIserrorShow(false)
    setData([])
    setNewTerminals([])
    setOrganiCode(orgCode)
    setGroupId(grpId)
    onClose()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsBtnLoading(true)
    setIserrorShow(true)
    const payload = {
      groupId: groupId,
      orgCode: organiCode,
      terminalSnList: newTerminals.map((terminalSn) => ({
        terminalSn,
        model: model,
      })),
    }
    api
      .post("/terminals", payload)
      .then((res) => {
        setErrorMessages([])
        setIserror(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setUpdateData(true)
        setTimeout(() => {
          setIsBtnLoading(false)
          setIsSuccess(false)
          setSuccessMessages([""])
          handleClearData()
          onClose()
        }, 4000)
      })
      .catch((error) => {
        setIsBtnLoading(false)
        setIsSuccess(false)
        RequestErrorHandeling(error, setIserror, setErrorMessages)
        setIserrorShow(true)
      })
  }

  const handleChange = (e) => {
    const value = e.target.value
    setData({
      ...data,
      [e.target.name]: value,
    })
    setIserror(false)
    setErrorMessages([])
  }
  const handleOrgsChange = (event) => {
    const value = event?.target.value
    setOrganiCode(value)
  }

  const handleGroupsChange = (event) => {
    const value = event?.target.value
    setGroupId(value)
  }
  const handleModelsChange = (event) => {
    const value = event?.target.value
    setModel(value)
  }

  const handleAddTerminals = (e) => {
    e.preventDefault()
    if (data.terminalSerial) {
      const arr = [...newTerminals]
      arr.push(data.terminalSerial)
      data.terminalSerial = ""
      setIsAdded(true)
      setNewTerminals(arr)
    }
  }

  const handleRemoveTerminals = (i) => {
    newTerminals.splice(i, 1)
    const arr = [...newTerminals]
    setIsAdded(true)
    setNewTerminals(arr)
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={open}
      PaperProps={{
        style: { borderRadius: "10px", width: "900px", margin: 0 },
      }}
    >
      <DialogTitle className="createTerminalsTitle">
        Create New Terminals
        <IconButton aria-label="cancel" onClick={handleClearData}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <div>
            <Alerts
              iserror={iserror}
              errorMessages={errorMessages}
              isSuccess={isSuccess}
              successMessages={successMessages}
              iserrorShow={iserrorShow}
            />
          </div>
          <Stack spacing={2} direction="row" sx={{ my: 2 }}>
            <OrgsDropdown
              orgCode={organiCode ? organiCode : ""}
              onChange={handleOrgsChange}
            />
            <GroupsDropdown
              orgCode={organiCode}
              groupId={groupId}
              onChange={handleGroupsChange}
              isRequired={true}
            />
          </Stack>
          <br />
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            sx={{ marginBottom: 2 }}
          >
            <TerminalModelsDropdown
              onChange={handleModelsChange}
              isRequired={true}
            />
            <TextField
              name="terminalSerial"
              value={data.terminalSerial}
              type="text"
              variant="outlined"
              color="secondary"
              label="Terminal Serial"
              fullWidth
              sx={{ mb: 4 }}
              onChange={handleChange}
            />
            <Button
              variant="contained"
              color="primary"
              sx={{ width: 150, height: 56 }}
              startIcon={<AddIcon />}
              onClick={handleAddTerminals}
            >
              Add
            </Button>
          </Stack>
          {isadded && (
            <Stack
              spacing={{ xs: 1, sm: 2 }}
              direction="row"
              useFlexGap
              flexWrap="wrap"
              alignItems="center"
            >
              {newTerminals?.map((terminal, i) => (
                <Chip
                  onDelete={() => handleRemoveTerminals(i)}
                  key={terminal}
                  label={terminal}
                />
              ))}
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={handleClearData} variant="outlined" color="error">
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            color="success"
            loading={isBtnLoading}
            variant="contained"
            loadingPosition="start"
            startIcon={<SaveIcon />}
          >
            Create
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CreateTerminalsModal
